import React from 'react';

import { IBasicStyledProps } from '@notino/react-styleguide-v20';

import { ImageLink, EImageSource } from '@sharedComponents/Images';
import { ReactFCV } from '@types';

import { IMAGE_HEIGHT, IMAGE_WIDTH } from '../constants';
import { ISizeProps } from '../model';
import { StyledImageCol } from '../styled';

export interface IImageProps extends ISizeProps, IBasicStyledProps {
  itemUrl?: string | null;
  imageUrl?: string;
}

export const Image: ReactFCV<IImageProps> = ({ imageUrl, itemUrl, ...rest }) => (
  <StyledImageCol xs={2} sm={1} {...rest}>
    {imageUrl && (
      <ImageLink
        width={IMAGE_WIDTH}
        height={IMAGE_HEIGHT}
        url={imageUrl}
        linkUrl={itemUrl}
        sourceKey={EImageSource.ORDER}
      />
    )}
  </StyledImageCol>
);
Image.displayName = 'GeneralProductItem.ImageWrapper';
